import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

interface SectionHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  className?: string;
}

/**
 * Nadpis sekce uvnitř stránky/karty s volitelným action slotem vpravo.
 *
 * Použití:
 *   <SectionHeader title="API klíče" actions={<RefreshButton onRefresh={refetch} />} />
 */
export function SectionHeader({ title, description, actions, className }: SectionHeaderProps) {
  return (
    <div className={cn('flex items-center justify-between', className)}>
      <div>
        <h2 className='text-sm font-semibold text-white'>{title}</h2>
        {description && <p className='text-xs text-gray-500 mt-0.5'>{description}</p>}
      </div>
      {actions && <div className='flex items-center gap-2'>{actions}</div>}
    </div>
  );
}
